module.exports = __webpack_public_path__ + "static/media/washingtonpost.com_news_the-fix_wp_2016_10_16_heres-the-snl-that-finally-went-too-far-for-donald-trump__plot.d73b3909.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/washingtonpost.com_news_the-fix_wp_2016_10_16_heres-the-snl-that-finally-went-too-far-for-donald-trump__plot.png
// module id = 434
// module chunks = 0